import React from 'react';
import { HiChevronLeft, HiChevronRight } from 'react-icons/hi';

import {
  canProceedToNextStep,
  isCrackmapWizardCompleteStep,
  WizardSelections,
  WizardStepId,
} from './wizardLogic';
import type { ActiveDefectLayerId } from 'state/surveyDataManager/activeLayersSlice';

export interface WizardFooterProps {
  readonly currentStep: WizardStepId;
  readonly selections: WizardSelections;
  readonly activeLayerIds: ReadonlySet<ActiveDefectLayerId>;
  readonly isSubmitting?: boolean;
  readonly isCatalogueLoading?: boolean;
  readonly onPrevious: () => void;
  readonly onNext: () => void;
  readonly onComplete: () => void;
}

function WizardFooter({
  currentStep,
  selections,
  activeLayerIds,
  isSubmitting = false,
  isCatalogueLoading = false,
  onPrevious,
  onNext,
  onComplete,
}: WizardFooterProps): JSX.Element {
  const canProceed = canProceedToNextStep(currentStep, selections, activeLayerIds);
  const isBusy = isSubmitting || isCatalogueLoading;
  const showComplete =
    currentStep === 6 || isCrackmapWizardCompleteStep(currentStep, selections);

  return (
    <footer className="sdm-add-layer-wizard__footer">
      <button
        type="button"
        className="sdm-add-layer-wizard__nav-button"
        onClick={onPrevious}
        disabled={currentStep === 1 || isBusy}
      >
        <HiChevronLeft aria-hidden />
        Previous
      </button>

      {showComplete ? (
        <button
          type="button"
          className="sdm-add-layer-wizard__nav-button sdm-add-layer-wizard__nav-button--primary"
          onClick={onComplete}
          disabled={!canProceed || isBusy}
          aria-busy={isSubmitting || undefined}
        >
          {isSubmitting ? 'Adding layer…' : 'Add layer'}
        </button>
      ) : (
        <button
          type="button"
          className="sdm-add-layer-wizard__nav-button sdm-add-layer-wizard__nav-button--primary"
          onClick={onNext}
          disabled={!canProceed || isBusy}
        >
          Next
          <HiChevronRight aria-hidden />
        </button>
      )}
    </footer>
  );
}

export default WizardFooter;
